module.exports = __webpack_public_path__ + "static/media/arrow-left.63586074.svg";